import React, { useEffect, useState } from 'react';
import { FilteringMobileWrapper } from './style';
import lodashDebounce from 'lodash.debounce';
import { useDispatch } from 'react-redux';

// Components
import DropDown from './DropDown';
import Button from 'components/common/Button';

// Libs
import Translation from 'libs/Translation';
import ModalManager from 'libs/ModalManager';

// Actions
import {getAPI} from 'redux/core/actions';

const MobileFiltering = ({ cities, specialties, educationLevels, webConfig }) => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState({});
    const [finalSpecialties, setFinalSpecialties] = useState([]);
    const [finalCities, setFinalCities] = useState([]);

    useEffect(() => {
        setFinalCities(cities);
    }, [cities])

    useEffect(() => {
        setFinalSpecialties(specialties);
    }, [specialties])

    const handleSearch = (e) => {
        const {value, name} = e.target;
        const newSearchValue = {[name]: value};
        setSearchValue({...searchValue, ...newSearchValue});
        
        if (name === 'city') {
            if (value) {
                dispatch(getAPI('getCities', {search: value}, 'nestApi'))
                    .then(res => {
                        setFinalCities(res);
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
            else {
                setFinalCities(cities);
            }
        }
        else if (name === 'specialty') {
            if (value) {
                dispatch(getAPI('getSpecialties', {SpecialtyType: 'SPECIALTY', search: value, lang: webConfig.lang}, 'nestApi'))
                    .then(res => {
                        setFinalSpecialties(res);
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
            else {
                setFinalSpecialties(specialties);
            }
        }
    }   

    const debouncedHandleSearch = lodashDebounce((e) => {handleSearch(e)}, 1000)
    
    return (
        <FilteringMobileWrapper>
            <DropDown 
                items={finalCities}
                searchValue={searchValue.city}
                handleSearch={debouncedHandleSearch}
                name="city"
                label={Translation.t('label.city')}
                placeholder={Translation.t('label.city')}
                expand={true}
                searchBar={true}
                specialties={specialties}
                educationLevels={educationLevels}
                cities={cities}
            />
            <DropDown 
                items={finalSpecialties}
                searchValue={searchValue.specialty}
                handleSearch={debouncedHandleSearch}
                name="specialty"
                label={Translation.t('label.specialty')}
                placeholder={Translation.t('label.specialty')}
                expand={true}
                searchBar={true}
                specialties={specialties}
                educationLevels={educationLevels}
                cities={cities}
            />
            <DropDown 
                items={educationLevels}
                name="educationLevel"
                label={Translation.t('label.education-level')}
                placeholder={Translation.t('label.education-level')}
                expand={true}
                specialties={specialties}
                educationLevels={educationLevels}
                cities={cities}
            />
            <div className='fixed-button'>
                <Button 
                    onClick={() => ModalManager.hide()}
                    className='button'
                >
                    {Translation.t('label.confirm')}
                </Button>
            </div>
        </FilteringMobileWrapper>  
    )
}

export default MobileFiltering;
